import config from './config';
//#endregion
//#region Functions
// feedback-api
// 1.0
// http://test5-bg-api-gateway.zhiketong.net[80]/feedback-api/swagger-ui.html
/**
 * 检查qa内容
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postCMerchantQaCheckQaContent(body, header) {
    var url = "/feedback-api/c/merchant_qa/check_qa_content";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取ai服务菜单
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getCMerchantQaGetAiMenu(query, header) {
    var url = "/feedback-api/c/merchant_qa/get_ai_menu";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取ai
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getCMerchantQaGetAiQaContent(query, header) {
    var url = "/feedback-api/c/merchant_qa/get_ai_qa_content";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * C端获取答案
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getCMerchantQaGetAnswer(query, header) {
    var url = "/feedback-api/c/merchant_qa/get_answer";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户问答配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getCMerchantQaGetMerchantQaConfig(query, header) {
    var url = "/feedback-api/c/merchant_qa/get_merchant_qa_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取猜你想问
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getCMerchantQaGetQaCustomerGuess(query, header) {
    var url = "/feedback-api/c/merchant_qa/get_qa_customer_guess";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取推荐
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getCMerchantQaGetQaCustomerRec(query, header) {
    var url = "/feedback-api/c/merchant_qa/get_qa_customer_rec";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * C端获取商户问答历史记录
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getCMerchantQaGetQaHistoryListByPage(query, header) {
    var url = "/feedback-api/c/merchant_qa/get_qa_history_list_by_page";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 新增/修改新需求
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postDemandApiAddRequirement(body, header) {
    var url = "/feedback-api/demandApi/addRequirement";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 录入需求价值(问题)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postDemandApiDoCorrelationRequirement(body, header) {
    var url = "/feedback-api/demandApi/doCorrelationRequirement";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除需求
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postDemandApiDoDelDemand(body, header) {
    var url = "/feedback-api/demandApi/doDelDemand";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 需求可视化列表下载
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getDemandApiDoDemandListDownload(query, header) {
    var url = "/feedback-api/demandApi/doDemandListDownload";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 问题列表下载
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getDemandApiDoFeedbackListDownload(query, header) {
    var url = "/feedback-api/demandApi/doFeedbackListDownload";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 反馈信息列表MIS下载
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getDemandApiDoFeedbackListMisDownload(query, header) {
    var url = "/feedback-api/demandApi/doFeedbackListMISDownload";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据excel导入需求
 * @param header The http request header parameters.
 */
export function postDemandApiDoImportExcel(header) {
    var url = "/feedback-api/demandApi/doImportExcel";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * 搁置需求可视化列表下载
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getDemandApiDoShelveFeedbackDownload(query, header) {
    var url = "/feedback-api/demandApi/doShelveFeedbackDownload";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 搁置需求
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postDemandApiDoshelveRequirement(body, header) {
    var url = "/feedback-api/demandApi/doshelveRequirement";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询需求价值(问题)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postDemandApiGetCorrelationRequirement(body, header) {
    var url = "/feedback-api/demandApi/getCorrelationRequirement";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询需求详情
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postDemandApiGetDemandDetails(body, header) {
    var url = "/feedback-api/demandApi/getDemandDetails";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询关联问题列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postDemandApiGetFeedbackList(body, header) {
    var url = "/feedback-api/demandApi/getFeedbackList";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取列表总数
 * @param header The http request header parameters.
 */
export function postDemandApiGetListCount(header) {
    var url = "/feedback-api/demandApi/getListCount";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * mis需求列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postDemandApiGetMmByHotel(body, header) {
    var url = "/feedback-api/demandApi/getMmByHotel";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取搁置需求
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postDemandApiGetshelveRequirement(body, header) {
    var url = "/feedback-api/demandApi/getshelveRequirement";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 脚本-更新原问题状态码
 * @param header The http request header parameters.
 */
export function getDoUpdataFeedbackStatus(header) {
    var url = "/feedback-api/doUpdataFeedbackStatus";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 删除AI菜单
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function postEbAiMenuDeleteAiMenu(query, header) {
    var url = "/feedback-api/eb/ai_menu/delete_ai_menu";
    return config.request({ url: url, method: 'post', query: query, header: header, });
}
/**
 * 获取AI菜单列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbAiMenuGetAiMenuList(query, header) {
    var url = "/feedback-api/eb/ai_menu/get_ai_menu_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取图标列表
 * @param header The http request header parameters.
 */
export function getEbAiMenuGetIconList(header) {
    var url = "/feedback-api/eb/ai_menu/get_icon_list";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * loadAiMenu
 * @param header The http request header parameters.
 */
export function getEbAiMenuLoadAiMenu(header) {
    var url = "/feedback-api/eb/ai_menu/load_ai_menu";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 保存AI菜单
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbAiMenuSaveAiMenu(body, header) {
    var url = "/feedback-api/eb/ai_menu/save_ai_menu";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 新增反馈信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbFeedbackAddFeedbackInfo(body, header) {
    var url = "/feedback-api/eb/feedback/addFeedbackInfo";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 回复问题
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbFeedbackAddFeedbackReply(body, header) {
    var url = "/feedback-api/eb/feedback/addFeedbackReply";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * eb用户反馈收集接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbFeedbackEbUserFeedback(body, header) {
    var url = "/feedback-api/eb/feedback/eb_user_feedback";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * eb用户反馈查询接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbFeedbackGetEbUserFeedback(query, header) {
    var url = "/feedback-api/eb/feedback/get_eb_user_feedback";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户问答配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbMerchantQaGetMerchantQaConfig(query, header) {
    var url = "/feedback-api/eb/merchant_qa/get_merchant_qa_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存商户问答配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbMerchantQaSaveMerchantQaConfig(body, header) {
    var url = "/feedback-api/eb/merchant_qa/save_merchant_qa_config";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 新增反馈信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function postFeedbackApiAddFeedbackInfo(body, header) {
    var url = "/feedback-api/feedback/api/addFeedbackInfo";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 回复问题
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function postFeedbackApiAddFeedbackReply(body, header) {
    var url = "/feedback-api/feedback/api/addFeedbackReply";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * addFeedbackSign
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postFeedbackApiAddFeedbackSign(body, header) {
    var url = "/feedback-api/feedback/api/addFeedbackSign";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 更新问题的需求状态
 * @param header The http request header parameters.
 */
export function postFeedbackApiDoUpdataRequirementStatusToFeedback(header) {
    var url = "/feedback-api/feedback/api/doUpdataRequirementStatusToFeedback";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * getAllFeedbackType
 * @param header The http request header parameters.
 */
export function getFeedbackApiGetAllFeedbackType(header) {
    var url = "/feedback-api/feedback/api/getAllFeedbackType";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * getFeedbackCount
 * @param header The http request header parameters.
 */
export function getFeedbackApiGetFeedbackCount(header) {
    var url = "/feedback-api/feedback/api/getFeedbackCount";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 查询问题详情
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postFeedbackApiGetFeedbackInfo(body, header) {
    var url = "/feedback-api/feedback/api/getFeedbackInfo";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * getFeedbackListEB
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postFeedbackApiGetFeedbackListEb(body, header) {
    var url = "/feedback-api/feedback/api/getFeedbackListEB";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * getFeedbackListMIS
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postFeedbackApiGetFeedbackListMis(body, header) {
    var url = "/feedback-api/feedback/api/getFeedbackListMIS";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * getFeedbackType
 * @param header The http request header parameters.
 */
export function getFeedbackApiGetFeedbackType(header) {
    var url = "/feedback-api/feedback/api/getFeedbackType";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 关联需求
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postFeedbackApiSetRequirementListId(body, header) {
    var url = "/feedback-api/feedback/api/setRequirementListId";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 设置问题为已解决
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postFeedbackApiSetSolve(body, header) {
    var url = "/feedback-api/feedback/api/setSolve";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 同步问题到效能平台
 * @param header The http request header parameters.
 */
export function getFeedbackApiSyncFeedbackToEp(header) {
    var url = "/feedback-api/feedback/api/sync_feedback_to_ep";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取api版本
 * @param header The http request header parameters.
 */
export function getGetVersions(header) {
    var url = "/feedback-api/getVersions";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 创建酒店知识库数据
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelDataCreateHotelDataSet(body, header) {
    var url = "/feedback-api/hotel_data/createHotelDataSet";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 创建酒店关键词数据
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelDataCreateHotelKeyword(body, header) {
    var url = "/feedback-api/hotel_data/createHotelKeyword";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * createQaDataSet
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelDataCreateQaDataSet(body, header) {
    var url = "/feedback-api/hotel_data/createQaDataSet";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * deleteQaDataSet
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelDataDeleteQaDataSet(body, header) {
    var url = "/feedback-api/hotel_data/deleteQaDataSet";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除酒店关键词数据
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelDataDeletedHotelKeyword(body, header) {
    var url = "/feedback-api/hotel_data/deletedHotelKeyword";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取酒店知识库数据列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelDataGetHotelDataSetByPage(query, header) {
    var url = "/feedback-api/hotel_data/getHotelDataSetByPage";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店关键词数据
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function postHotelDataGetHotelKeywordById(query, header) {
    var url = "/feedback-api/hotel_data/getHotelKeywordById";
    return config.request({ url: url, method: 'post', query: query, header: header, });
}
/**
 * 获取酒店关键词数据列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelDataGetHotelKeywordPage(query, header) {
    var url = "/feedback-api/hotel_data/getHotelKeywordPage";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * getHotelProductList
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelDataGetHotelProductList(query, header) {
    var url = "/feedback-api/hotel_data/getHotelProductList";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店问答数据列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelDataGetHotelQaDataSetByPage(query, header) {
    var url = "/feedback-api/hotel_data/getHotelQaDataSetByPage";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店问答历史问答数据列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelDataGetHotelQaHistoryByPage(query, header) {
    var url = "/feedback-api/hotel_data/getHotelQaHistoryByPage";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * getQaDataSet
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getHotelDataGetQaDataSet(query, header) {
    var url = "/feedback-api/hotel_data/getQaDataSet";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 修改酒店关键词数据
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelDataUpdateHotelKeyword(body, header) {
    var url = "/feedback-api/hotel_data/updateHotelKeyword";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * updateQaDataSet
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelDataUpdateQaDataSet(body, header) {
    var url = "/feedback-api/hotel_data/updateQaDataSet";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * uploadHotelProduct
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelDataUploadHotelProduct(body, header) {
    var url = "/feedback-api/hotel_data/uploadHotelProduct";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * uploadQaDataSet
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postHotelDataUploadQaDataSet(body, header) {
    var url = "/feedback-api/hotel_data/uploadQaDataSet";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 同步反馈问题到效能平台
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisFeedbackSyncFeedbackToEp(query, header) {
    var url = "/feedback-api/mis/feedback/sync_feedback_to_ep";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 删除文档
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHelpCenterContentDeleteHelpCenterDoc(query, header) {
    var url = "/feedback-api/mis/help_center_content/delete_help_center_doc";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 删除问答内容
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHelpCenterContentDeleteQaContent(query, header) {
    var url = "/feedback-api/mis/help_center_content/delete_qa_content";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取帮助中心内容
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHelpCenterContentGetHelpCenterContent(query, header) {
    var url = "/feedback-api/mis/help_center_content/get_help_center_content";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取帮助中心内容日志
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHelpCenterContentGetHelpCenterLogs(query, header) {
    var url = "/feedback-api/mis/help_center_content/get_help_center_logs";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取问答内容列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHelpCenterContentGetQaContentList(query, header) {
    var url = "/feedback-api/mis/help_center_content/get_qa_content_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存帮助中心内容
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHelpCenterContentSaveHelpCenterContent(body, header) {
    var url = "/feedback-api/mis/help_center_content/save_help_center_content";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存问答内容
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHelpCenterContentSaveQaContent(body, header) {
    var url = "/feedback-api/mis/help_center_content/save_qa_content";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存问答内容排序
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHelpCenterContentSaveQaContentSort(body, header) {
    var url = "/feedback-api/mis/help_center_content/save_qa_content_sort";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * test
 * @param header The http request header parameters.
 */
export function getMisHelpCenterContentTest(header) {
    var url = "/feedback-api/mis/help_center_content/test";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 上传文档
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHelpCenterContentUploadHelpCenterDoc(body, header) {
    var url = "/feedback-api/mis/help_center_content/upload_help_center_doc";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除帮助中心标签
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHelpCenterLabelDeleteHelpCenterLabel(query, header) {
    var url = "/feedback-api/mis/help_center_label/delete_help_center_label";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 删除帮助中心标签关系
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHelpCenterLabelDeleteHelpCenterLabelRelation(query, header) {
    var url = "/feedback-api/mis/help_center_label/delete_help_center_label_relation";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询帮助中心标签详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHelpCenterLabelGetHelpCenterDetail(query, header) {
    var url = "/feedback-api/mis/help_center_label/get_help_center_detail";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询帮助中心标签
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHelpCenterLabelGetHelpCenterLabelList(query, header) {
    var url = "/feedback-api/mis/help_center_label/get_help_center_label_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存帮助中心标签
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHelpCenterLabelSaveHelpCenterLabel(body, header) {
    var url = "/feedback-api/mis/help_center_label/save_help_center_label";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存帮助中心标签关系
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHelpCenterLabelSaveHelpCenterLabelRelation(body, header) {
    var url = "/feedback-api/mis/help_center_label/save_help_center_label_relation";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除侧边栏
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHelpCenterSidebarDeleteSidebar(query, header) {
    var url = "/feedback-api/mis/help_center_sidebar/delete_sidebar";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 侧边栏详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHelpCenterSidebarGetSidebarDetail(query, header) {
    var url = "/feedback-api/mis/help_center_sidebar/get_sidebar_detail";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 保存侧边栏
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHelpCenterSidebarSaveSidebar(body, header) {
    var url = "/feedback-api/mis/help_center_sidebar/save_sidebar";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 分页查询侧边栏列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHelpCenterSidebarSidebarList(query, header) {
    var url = "/feedback-api/mis/help_center_sidebar/sidebar_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 删除帮助中心树形结构
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHelpCenterStructureDeleteHelpCenterStructure(query, header) {
    var url = "/feedback-api/mis/help_center_structure/delete_help_center_structure";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 下载帮助中心树形结构
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHelpCenterStructureDownloadHelpCenterList(query, header) {
    var url = "/feedback-api/mis/help_center_structure/download_help_center_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询帮助中心树形结构
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHelpCenterStructureGetHelpCenterStructureList(query, header) {
    var url = "/feedback-api/mis/help_center_structure/get_help_center_structure_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 移动帮助中心树形结构
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHelpCenterStructureMoveHelpCenterStructure(body, header) {
    var url = "/feedback-api/mis/help_center_structure/move_help_center_structure";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存帮助中心树形结构
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHelpCenterStructureSaveHelpCenterStructure(body, header) {
    var url = "/feedback-api/mis/help_center_structure/save_help_center_structure";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 添加首页模块
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHomeModuleAddHelpCenterModule(body, header) {
    var url = "/feedback-api/mis/home_module/add_help_center_module";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 添加首页模块关系
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHomeModuleAddHelpCenterModuleRelation(body, header) {
    var url = "/feedback-api/mis/home_module/add_help_center_module_relation";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除首页模块
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHomeModuleDeleteHelpCenterModule(query, header) {
    var url = "/feedback-api/mis/home_module/delete_help_center_module";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 删除首页模块关系
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisHomeModuleDeleteHelpCenterModuleRelation(query, header) {
    var url = "/feedback-api/mis/home_module/delete_help_center_module_relation";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询首页模块
 * @param header The http request header parameters.
 */
export function getMisHomeModuleGetHelpCenterHomePage(header) {
    var url = "/feedback-api/mis/home_module/get_help_center_home_page";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 添加热词
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotwordAdd(body, header) {
    var url = "/feedback-api/mis/hotword/add";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除搜索词
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotwordDelete(body, header) {
    var url = "/feedback-api/mis/hotword/delete";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取热词列表
 * @param header The http request header parameters.
 */
export function getMisHotwordList(header) {
    var url = "/feedback-api/mis/hotword/list";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 设置默认搜索词
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotwordSetDefault(body, header) {
    var url = "/feedback-api/mis/hotword/set_default";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 设置排序
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisHotwordSort(body, header) {
    var url = "/feedback-api/mis/hotword/sort";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 发送需求状态变更信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postOpenApiFeedbackApiSendFeedbackMsg(body, header) {
    var url = "/feedback-api/open_api/feedback/api/send_feedback_msg";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通过url获取侧边栏详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getPublicHelpCenterGetEbSidebarDetail(query, header) {
    var url = "/feedback-api/public/help_center/get_eb_sidebar_detail";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取用户点击帮助按钮的信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postPublicHelpCenterGetHelpBtnInfo(body, header) {
    var url = "/feedback-api/public/help_center/get_help_btn_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取内容接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getPublicHelpCenterGetHelpCenterDetail(query, header) {
    var url = "/feedback-api/public/help_center/get_help_center_detail";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取结构接口
 * @param header The http request header parameters.
 */
export function getPublicHelpCenterGetHelpCenterStructure(header) {
    var url = "/feedback-api/public/help_center/get_help_center_structure";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取数据类型
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getPublicHelpCenterGetHelpCenterType(query, header) {
    var url = "/feedback-api/public/help_center/get_help_center_type";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取热词列表
 * @param header The http request header parameters.
 */
export function getPublicHelpCenterGetHotwordList(header) {
    var url = "/feedback-api/public/help_center/get_hotword_list";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 保存用户点击帮助按钮的信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postPublicHelpCenterSaveHelpBtnInfo(body, header) {
    var url = "/feedback-api/public/help_center/save_help_btn_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * nlp搜索接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getPublicHelpCenterSearchDetailByKeyWord(query, header) {
    var url = "/feedback-api/public/help_center/search_detail_by_key_word";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 搜索接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getPublicHelpCenterSelectDetailByKeyWord(query, header) {
    var url = "/feedback-api/public/help_center/select_detail_by_key_word";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取首页配置
 * @param header The http request header parameters.
 */
export function getPublicHelpCenterSelectHelpCenterHome(header) {
    var url = "/feedback-api/public/help_center/select_help_center_home";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * testGetWsChGeneral
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getPublicHelpCenterTestGetWsChGeneral(query, header) {
    var url = "/feedback-api/public/help_center/testGetWsChGeneral";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 帮助中心端获取答案
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getPublicMerchantQaGetAnswer(query, header) {
    var url = "/feedback-api/public/merchant_qa/get_answer";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取答案对应的帮助中心url
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getPublicMerchantQaGetQaHelpCenterUrlList(query, header) {
    var url = "/feedback-api/public/merchant_qa/get_qa_help_center_url_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户问答历史记录
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getPublicMerchantQaGetQaHistoryListByPage(query, header) {
    var url = "/feedback-api/public/merchant_qa/get_qa_history_list_by_page";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取用户状态
 * @param header The http request header parameters.
 */
export function getPublicUserSelectUserType(header) {
    var url = "/feedback-api/public/user/select_user_type";
    return config.request({ url: url, method: 'get', header: header, });
}
//#endregion
